import React from 'react';
import { useParams } from 'react-router-dom';
import AppLayout from '../../layout/app.layout';
import ManageContentOrder from '../../components/categories/category-content-order';

const ContentCategoryContentOrder = () => {
  const { id } = useParams();
  const pageTitle = 'Content / Category';

  return (
    <AppLayout pageTitle={pageTitle}>
      <ManageContentOrder id={id} />
    </AppLayout>
  );
};

export default ContentCategoryContentOrder;
